import React from "react";
import AcademyContent from "../../components/AcademyContent";
import TitleFormat from "../../components/TitleFormat";
import { useTranslation } from "react-i18next";
import { Seo } from "../../components/Seo";

const Academy = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("newsEducation.academy.seo.title")} description={t("newsEducation.academy.seo.des")} path="/news" />
      <TitleFormat text={t("newsEducation.academy.title")} />
      <AcademyContent />
    </>
  );
};

export default Academy;
